import { INIT_EDIT_GALLERY_FILTERS } from 'constants/index';

import actions from '../actions/actionTypes';

export const INITIAL_STATE = {
  data: [],
  loading: false,
  error: null,
  searchValue: '',
  categoryId: '',
  filters: INIT_EDIT_GALLERY_FILTERS,
  activeFilters: INIT_EDIT_GALLERY_FILTERS,
};

const editGallery = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actions.EDIT_GALLERY_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actions.EDIT_GALLERY_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...payload.data],
        categoryId: payload.categoryId,
      };
    case actions.EDIT_GALLERY_UPDATE:
      return {
        ...state,
        loading: false,
        data: [...state.data, ...payload.data],
      };
    case actions.EDIT_GALLERY_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    case actions.SET_EDIT_GALLERY_SEARCH_VALUE:
      return {
        ...state,
        searchValue: payload,
      };
    case actions.EDIT_GALLERY_FILTERS_SUCCESS:
      return {
        ...state,
        filters: payload,
        loading: false,
      };
    case actions.SET_EDIT_GALLERY_ACTIVE_FILTERS:
      return {
        ...state,
        activeFilters: payload,
      };
    default:
      return state;
  }
};

export default editGallery;
